// Route path constants live OUTSIDE router.tsx on purpose: pages importing
// them from the router module created a cycle (router → routeTree.gen →
// route files → pages → router) that broke SSR module evaluation with
// "Cannot access '__vite_ssr_import_2__' before initialization".
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  ORDER_MANAGEMENT: '/order-management',
  INVOICE: '/invoice',
  ORDER_DETAIL: (orderId: string) => `/order-management/${orderId}`,
  BID_MANAGEMENT: '/bid-management',
  CRM_CLIENTS: '/crm/clients',
  CRM_OPPORTUNITIES: '/crm/opportunities',
  INVENTORY_UPLOAD: '/inventory-upload',
  USER_MANAGEMENT: '/user-management',
  ACCOUNT_INTEGRATION: '/account-integration',
  SETTINGS: '/settings',
  WAREHOUSE: '/warehouse',
  WAREHOUSE_ORDER_DETAIL: (orderId: string) => `/warehouse/orders/${orderId}`,
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
